/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  // Rule list mutations
  [types.GET_RULES_REQUEST]: state => {
    state.loadingRules = true;
    state.loadingRulesFailed = false;
    state.loadingRulesSuccess = false;
    state.loadingRulesError = null;
  },

  [types.GET_RULES_FAILURE]: (state, error) => {
    state.loadingRules = false;
    state.loadingRulesFailed = true;
    state.loadingRulesSuccess = false;
    state.loadingRulesError = error;
  },

  [types.GET_RULES_SUCCESS]: (state, response) => {
    state.loadingRules = false;
    state.loadingRulesFailed = false;
    state.loadingRulesSuccess = true;
    state.loadingRulesError = null;
    state.rules = response.results;
  },

  // Single rule mutations
  [types.GET_RULE_REQUEST]: state => {
    state.loadingRule = true;
    state.loadingRuleFailed = false;
    state.loadingRuleSuccess = false;
    state.loadingRuleError = null;
  },

  [types.GET_RULE_FAILURE]: (state, error) => {
    state.loadingRule = false;
    state.loadingRuleFailed = true;
    state.loadingRuleSuccess = false;
    state.loadingRuleError = error;
  },

  [types.GET_RULE_SUCCESS]: (state, response) => {
    state.loadingRule = false;
    state.loadingRuleFailed = false;
    state.loadingRuleSuccess = true;
    state.loadingRuleError = null;
    state.currentRule = response;
  },

  // Create rule mutations
  [types.CREATE_RULE_REQUEST]: state => {
    state.creatingRule = true;
    state.creatingRuleFailed = false;
    state.creatingRuleSuccess = false;
    state.creatingRuleError = null;
  },

  [types.CREATE_RULE_FAILURE]: (state, error) => {
    state.creatingRule = false;
    state.creatingRuleFailed = true;
    state.creatingRuleSuccess = false;
    state.creatingRuleError = error;
  },

  [types.CREATE_RULE_SUCCESS]: (state, response) => {
    state.creatingRule = false;
    state.creatingRuleFailed = false;
    state.creatingRuleSuccess = true;
    state.creatingRuleError = null;
    state.rules.push(response);
  },

  // update rule mutations
  [types.UPDATE_RULE_REQUEST]: state => {
    state.updatingRule = true;
    state.updatingRuleFailed = false;
    state.updatingRuleSuccess = false;
    state.updatingRuleError = null;
  },

  [types.UPDATE_RULE_FAILURE]: (state, error) => {
    state.updatingRule = false;
    state.updatingRuleFailed = true;
    state.updatingRuleSuccess = false;
    state.updatingRuleError = error;
  },

  [types.UPDATE_RULE_SUCCESS]: state => {
    state.updatingRule = false;
    state.updatingRuleFailed = false;
    state.updatingRuleSuccess = true;
    state.updatingRuleError = null;
  },

  // Delete rule mutations
  [types.DELETE_RULE_REQUEST]: state => {
    state.deletingRule = true;
    state.deletingRuleFailed = false;
    state.deletingRuleSuccess = false;
    state.deletingRuleError = null;
  },

  [types.DELETE_RULE_FAILURE]: (state, error) => {
    state.deletingRule = false;
    state.deletingRuleFailed = true;
    state.deletingRuleSuccess = false;
    state.deletingRuleError = error;
  },

  [types.DELETE_RULE_SUCCESS]: (state, ruleIndex) => {
    state.deletingRule = false;
    state.deletingRuleFailed = false;
    state.deletingRuleSuccess = true;
    state.deletingRuleError = null;
    state.rules.splice(ruleIndex, 1);
  },

  // Rule fields mutations
  [types.GET_RULE_FIELDS_REQUEST]: state => {
    state.loadingRuleFields = true;
    state.loadingRuleFieldsFailed = false;
    state.loadingRuleFieldsSuccess = false;
    state.loadingRuleFieldsError = null;
  },

  [types.GET_RULE_FIELDS_FAILURE]: (state, error) => {
    state.loadingRuleFields = false;
    state.loadingRuleFieldsFailed = true;
    state.loadingRuleFieldsSuccess = false;
    state.loadingRuleFieldsError = error;
  },

  [types.GET_RULE_FIELDS_SUCCESS]: (state, response) => {
    state.loadingRuleFields = false;
    state.loadingRuleFieldsFailed = false;
    state.loadingRuleFieldsSuccess = true;
    state.loadingRuleFieldsError = null;
    state.ruleFields = response;
  },

  // Modifiers on current rule
  [types.SET_RULE_TITLE]: (state, title) => {
    state.currentRule = { ...state.currentRule, title };
  },

  [types.SET_RULE_EVENT]: (state, event) => {
    state.currentRule = { ...state.currentRule, events: event };
  },

  [types.ADD_RULE_CONDITION]: state => {
    const conditions = [...state.currentRule.conditions, {}];
    state.currentRule = { ...state.currentRule, conditions };
  },

  [types.REMOVE_RULE_CONDITION]: (state, index) => {
    state.currentRule = {
      ...state.currentRule,
      conditions: state.currentRule.conditions.filter(
        (_condition, conditionIndex) => index !== conditionIndex,
      ),
    };
  },

  [types.SET_RULE_CONDITION]: (state, [index, condition]) => {
    state.currentRule.conditions[index] = condition;
  },

  [types.ADD_RULE_ACTION]: state => {
    const actions = [...state.currentRule.actions, {}];
    state.currentRule = { ...state.currentRule, actions };
  },

  [types.REMOVE_RULE_ACTION]: (state, index) => {
    state.currentRule = {
      ...state.currentRule,
      actions: state.currentRule.actions.filter((_action, actionIndex) => index !== actionIndex),
    };
  },

  [types.SET_RULE_ACTION]: (state, [index, action]) => {
    state.currentRule.actions[index] = action;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/mutations.js